<!--
Phone number as string vs number
-->
<template>
  <div class="form-wrap">
    <Modal
      v-if="modalActive"
      :modalMessage="modalMessage"
      @close-modal="closeModal"
    />
    <Loading v-if="loading" />
    <form class="register">
      <div class="home">
        <img @click.prevent="goHome" src="../assets/home.jpeg" alt="Home" />
        <p class="login-register">
          Already Have An Account?
          <router-link class="router-link" :to="{ name: 'Login' }">
            Log In</router-link
          >
        </p>
      </div>
      <h2>Create Your S-O-S Account</h2>
      <div class="fill-form">
        <div class="inputs">
          <div class="input">
            <input type="text" placeholder="First Name" v-model="firstName" />
            <user class="icon" />
          </div>
          <div class="input">
            <input type="text" placeholder="Last Name" v-model="lastName" />
            <user class="icon" />
          </div>
          <div class="input">
            <input type="text" placeholder="Username" v-model="username" />
            <user class="icon" />
          </div>
          <div class="input">
            <input
              type="tel"
              placeholder="Phone Number"
              v-model="phoneNumber"
            />
            <user class="icon" />
          </div>
          <div class="input">
            <input type="text" placeholder="Email" v-model="email" />
            <email class="icon" />
          </div>
          <div class="input">
            <input type="password" placeholder="Password" v-model="password" />
            <password class="icon" />
          </div>
          <div v-if="error" class="error">{{ this.errorMsg }}</div>
        </div>
      </div>
      <div class="sign-up">
        <button @click.prevent="register">
          Sign Up
        </button>
      </div>
      <div class="angle"></div>
    </form>
    <div class="background"></div>
  </div>
</template>

<script>
import email from "../assets/Icons/envelope-regular.svg";
import password from "../assets/Icons/lock-alt-solid.svg";
import user from "../assets/Icons/user-alt-light.svg";
import Modal from "../components/Modal";
import Loading from "../components/Loading";
import firebase from "firebase/app";
import "firebase/auth";
import db from "../firebase/firebaseInit";

export default {
  name: "Register",
  components: {
    email,
    password,
    user,
    Modal,
    Loading,
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      username: "",
      phoneNumber: "",
      email: "",
      password: "",
      error: false,
      errorMsg: "",
      modalActive: false,
      modalMessage: "",
      loading: false,
    };
  },
  methods: {
    closeModal() {
      this.firstName = "";
      this.lastName = "";
      this.username = "";
      this.phoneNumber = "";
      this.email = "";
      this.password = "";

      this.modalActive = !this.modalActive;

      this.$router.push({ name: "Dashboard" });
    },
    goHome() {
      this.$router.push({ name: "Home" });
    },
    async register() {
      if (
        this.email !== "" &&
        this.firstName !== "" &&
        this.lastName !== "" &&
        this.username !== "" &&
        this.phoneNumber !== "" &&
        this.password !== ""
      ) {
        this.error = false;
        this.errorMsg = "";

        this.loading = true;

        //Firebase Authetication
        try {
          const firebaseAuth = await firebase.auth();
          const createUser = await firebaseAuth.createUserWithEmailAndPassword(
            this.email,
            this.password
          );
          const result = await createUser;
          const dataBase = db.collection("users").doc(result.user.uid);
          await dataBase.set({
            admin: false,
            firstName: this.firstName,
            lastName: this.lastName,
            username: this.username,
            phoneNumber: this.phoneNumber,
            email: this.email,
            cart: [],
            orders: [],
            ordersDelivered: [],
          });

          this.modalMessage = "You Have Successfully Registered With Us!";
          this.loading = false;
          this.modalActive = true;
        } catch (err) {
          this.loading = false;
          this.error = true;
          this.errorMsg = err.message;
        }

        return;
      }

      this.loading = false;
      this.error = true;
      this.errorMsg = "Please fill out all the fields";
      return;
    },
  },
};
</script>

<style lang="scss" scoped>
// Minor changes due to bugs in viewing in smaller devices :)
.register {
  //min-height: 100vh;
  //overflow: auto;
  h2 {
    min-width: 350px;
  }

  @media (max-width: 800px) {
    .fill-form {
      min-width: 90vw;
    }
  }

  @media (min-width: 800px) {
    display: flex;
    flex-direction: column;
    //gap: 20px;

    .home {
      display: flex;
      justify-content: center;
      flex-direction: column;
      flex-basis: 20%;
      //border: 3px solid black;
    }

    .fill-form {
      flex-basis: 70%;
      max-height: 45vh;
      overflow: scroll;
      display: flex;
      //justify-content: center;
      flex-direction: column;
      //border: 3px solid black;
      min-width: 350px;
    }

    .sign-up {
      //border: 3px solid black;
      flex-basis: 10%;
      display: flex;
      justify-content: center;
      padding: auto;
      //align-items: center;
      //flex-direction: column;
    }
  }
}
</style>
